import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { CgArrowLeft } from 'react-icons/cg';
import authService from '../services/authService';
import logo from '../assets/images/mainIcon.jpeg';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await authService.resetPassword(email);
      setSuccess(true);
      toast.success('Password reset link has been sent to your email');
    } catch (error) {
      const errorMessage = error?.error || 'Failed to send reset link. Please try again.';
      setError(errorMessage);
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-primary min-h-screen pt-12 md:pt-20 pb-6 px-2 md:px-0">
      <main className="bg-white max-w-lg mx-auto p-8 md:p-12 my-10 rounded-lg shadow-2xl">
        <section className="mt-10">
          <img src={logo} alt="Logo" className='w-52 m-auto'/>
          
          <div className='flex gap-4 items-center justify-center mt-6'>
            <button 
              onClick={() => navigate('/')} 
              className='text-primary hover:text-blue-700'
            >
              <CgArrowLeft size={24}/>
            </button>
            <h2 className="text-2xl font-bold">Reset Password</h2>
          </div>

          {success ? (
            <div className="text-center mt-8">
              <div className="mb-4 p-3 bg-green-100 border border-green-400 text-green-700 rounded">
                Password reset link has been sent to your email address.
              </div>
              <p className="mb-4">Please check your email for instructions to reset your password.</p>
              <Link to="/" className="text-primary hover:underline">
                Return to Login
              </Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="mt-8">
              {error && (
                <div className="mb-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded">
                  {error}
                </div>
              )}
              
              <div className="mb-4">
                <label htmlFor="email" className="block mb-1 text-gray-700">
                  Email Address
                </label>
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className={`input input-bordered w-full ${error ? 'border-red-500' : ''}`}
                  disabled={loading}
                  placeholder="Enter your email address"
                />
              </div>

              <button
                type="submit"
                className={`w-full bg-primary hover:bg-slatext-slate-500 text-white font-bold py-2 rounded shadow-lg hover:shadow-xl transition duration-200 ${
                  loading ? 'opacity-50 cursor-not-allowed' : ''
                }`}
                disabled={loading}
              >
                {loading ? 'Sending...' : 'Send Reset Link'}
              </button>

              <div className="text-center mt-4">
                <Link to="/" className="text-primary hover:underline">
                  Back to Login
                </Link>
              </div>
            </form>
          )}
        </section>
      </main>

      <div className="max-w-lg mx-auto text-center mt-12 mb-6">
        <p className="text-white mb-2">Adira Logistics System &copy; {new Date().getFullYear()}</p>
        <div className="flex justify-center space-x-4">
          <Link to="/privacy-policy" className="text-white hover:text-gray-200 text-sm underline">
            Privacy Policy
          </Link>
          <Link to="/terms-of-service" className="text-white hover:text-gray-200 text-sm underline">
            Terms of Service
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;